export default "__VITE_ASSET__08585b4f__"